import React, {useEffect} from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const MobileUserScale = ({ clickNext = () => {}, clickPrev = () => {}, clicked}) => {
    useEffect(() => {
        if (clicked) {
            clickNext("")
        }
    }, [clicked]);

  return (
    <div className="user-scale">
        <div className={'img-wrap'}>
            <Image src="/static/image/questionnaire/weight-loss/userScale/UserScale img_bg.png" alt="Img" className="img object-cover"/>
        </div>

      <div className="contents">
        <div className="title">
            <div className={"main-title"}>
                1,000,000+ People
            </div>
          <p className="subtitle">
              achieved weight loss, with a combined total of 12 million pounds lost!
          </p>
        </div>
      </div>
    </div>
  );
};
